import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Modal from 'react-modal';
import { Provider } from 'react-redux';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
// import { LoaderProvider } from '../src/services/LoaderContext';
import { BrowserRouter as Router } from 'react-router-dom';
import { LoaderProvider } from "./services/loadercontext";
import store from './Store/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
const client = new ApolloClient({
  //graphql dev and staging url
  // uri: 'https://ndhm.archents.com/graphql',
  //graphql prod url
  uri: 'https://acianadocisncontentmangment.azurewebsites.net/graphql',
  cache: new InMemoryCache(),
});
Modal.setAppElement('#root');


//For Prod
const basename = process.env.PUBLIC_URL || '/';

// For New staging Test and dev
// const basename = process.env.PUBLIC_URL || '/adminui/';
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <Provider store={store}>
        <LoaderProvider>
          <Router basename={basename}>
            <App />
          </Router>
        </LoaderProvider>
      </Provider>
    </ApolloProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
